/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateWorkLogDto } from '../../models/update-work-log-dto';
import { WorkLog } from '../../models/work-log';

export interface WorkLogsControllerUpdate$Params {
  id: string;
      body: UpdateWorkLogDto
}

export function workLogsControllerUpdate(http: HttpClient, rootUrl: string, params: WorkLogsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkLog>> {
  const rb = new RequestBuilder(rootUrl, workLogsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkLog>;
    })
  );
}

workLogsControllerUpdate.PATH = '/work-logs/{id}';
